import { CSS_PREFIX as r, REM_FONT_SIZE as c, SCALE_FROM_VIEWPORT_SIZE as n } from "../constants.js";
function o(t) {
  return `${r}${t}`;
}
function u(t, e) {
  return `${t}${r}${e}`;
}
function f(t) {
  return `${t / c}rem`;
}
function E(t, e) {
  const s = e > n ? Math.round(1e3 * (e / n)) / 1e3 : 1;
  return t * s;
}
const I = o, S = u;
export {
  S as cssTI,
  I as cssX,
  f as getRem,
  E as getScaledPixels,
  u as getTestIdWithCssPrefix,
  o as getWithCssPrefix
};
